import Card, { ContentCard } from '@ingka/card';
import AspectRatioBox from '@ingka/aspect-ratio-box';
import Image from '@ingka/image';
import PencilIcon from '@ingka/ssr-icon/paths/pencil';
import { PlannerConfigEntityPhraseStrings } from '@/services/configurator/PlannerConfigTypes';
import { ArrowBigDown } from 'lucide-react';
import { Alert, AlertTitle } from '@/components/ui/alert';
import { renderPhraseString } from './util';

const createImgSrcSet = (plannerImg: string | undefined | null): string => {
  if (plannerImg) {
    return `${plannerImg}?f=xxxl 1400w,
    ${plannerImg}?f=xxl 950w,
    ${plannerImg}?f=xl 800w,
    ${plannerImg}?f=l 750w,
    ${plannerImg}?f=m 600w,
    ${plannerImg}?f=s 500w,
    ${plannerImg}?f=xs 400w,
    ${plannerImg}?f=xxs 300w,
    ${plannerImg}?f=xxxs 240w`;
  }
  return '';
};

type BannerLargePreviewProps = {
  showInPages?: string[];
  headerVisible: boolean;
  imageUrl?: string;
  phraseStrings?: PlannerConfigEntityPhraseStrings;
  className?: string;
};

export const BannerLargePreview = (props: BannerLargePreviewProps) => {
  const { showInPages, headerVisible, imageUrl, phraseStrings } = props;
  const IMAGE_MEDIA_QUERY_SIZES = '(min-width: 37.5em) 40vw, 90vw';
  const showInPagesActive =
    showInPages && (showInPages.includes('plp') || showInPages.includes('pip'));
  return (
    <>
      {showInPagesActive && (
        <div className={`w-1/2 ${props.className}`}>
          {headerVisible && (
            <Alert className='mb-4 border-slate-800 bg-slate-800  text-white'>
              <ArrowBigDown className='h-4 w-4' />
              <AlertTitle className='font-bold'>PIP and PLP banner</AlertTitle>
            </Alert>
          )}
          <Card
            className='plann-large-fragment-with-deeplink mb-2'
            mediaPosition={'leading'}
            media={
              imageUrl && (
                <AspectRatioBox ratio='16:9'>
                  <Image
                    alt={renderPhraseString('large-title', phraseStrings)}
                    sizes={IMAGE_MEDIA_QUERY_SIZES}
                    src={`${imageUrl}?f=s`}
                    srcSet={createImgSrcSet(imageUrl)}
                    loading={'lazy'}
                  />
                </AspectRatioBox>
              )
            }
            content={
              <ContentCard
                id={'plann-large-fragment-with-deeplink'}
                label={renderPhraseString('type', phraseStrings)}
                title={renderPhraseString('large-title', phraseStrings)}
                titleHeadingTag='h2'
                body={renderPhraseString('large-description', phraseStrings)}
                buttonProps={{
                  text: renderPhraseString('cta', phraseStrings),
                  iconPosition: 'leading',
                  ssrIcon: PencilIcon,
                  fluid: false,
                }}
                onCardClick={() => {}}
              />
            }
          />
        </div>
      )}
    </>
  );
};
